import { h } from 'preact';
import { useState } from 'preact/hooks';
import { useShopware } from '../shopware/ShopwareContext';
import type { Order as ShopwareOrder } from '../shopware/shopwareApi';

export const OrdersDebugBox = () => {
  const { login, logout, fetchOrders, fetchCustomer } = useShopware();

  const [isLoggingIn, setIsLoggingIn] = useState<boolean>(false);
  const [isLoggingOut, setIsLoggingOut] = useState<boolean>(false);
  const [isFetchingOrders, setIsFetchingOrders] = useState<boolean>(false);
  const [isFetchingCustomer, setIsFetchingCustomer] = useState<boolean>(false);
  const [shopwareOrders, setShopwareOrders] = useState<ShopwareOrder[]>([]);

  const handleLogin = async () => {
    setIsLoggingIn(true);
    try {
      await login();
    } catch (error) {
      //alert('Login fehlgeschlagen. Bitte versuchen Sie es erneut.');
    } finally {
      setIsLoggingIn(false);
    }
  };

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
    } catch (error) {
      //alert('Logout fehlgeschlagen. Bitte versuchen Sie es erneut.');
    } finally {
      setIsLoggingOut(false);
    }
  };

  const handleFetchOrders = async () => {
    setIsFetchingOrders(true);
    try {
      const result = await fetchOrders({
        'total-count-mode': 'exact',
        associations: {
          lineItems: {
            associations: {
              cover: {},
            },
          },
          documents: {},
          deliveries: {
            associations: {
              stateMachineState: {},
            },
          },
          stateMachineState: {},
        },
      });

      // Update the UI with the fetched orders
      setShopwareOrders(result.elements);
    } catch (error) {
      //alert('Fehler beim Abrufen der Bestellungen. Bitte versuchen Sie es erneut.');
    } finally {
      setIsFetchingOrders(false);
    }
  };

  const handleFetchCustomer = async () => {
    setIsFetchingCustomer(true);
    try {
      const customer = await fetchCustomer();
      // Optionally update the UI with the fetched customer data
    } catch (error) {
      //alert('Fehler beim Abrufen der Kundendaten. Bitte versuchen Sie es erneut.');
    } finally {
      setIsFetchingCustomer(false);
    }
  };

  // Test function to fetch unique statuses using aggregations (API currently blocks this)
  const handleTestAggregations = async () => {
    try {
      const result = await fetchOrders({
        limit: 1,
        aggregations: [
          {
            name: 'statuses',
            type: 'terms',
            field: 'deliveries.stateMachineState.name',
          },
        ],
      });
    } catch (error) {
      // Error handled silently
    }
  };

  const handleModifyContextToken = () => {
    // Get current cookie value
    const cookies = document.cookie.split(';');
    let currentToken = '';
    
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'sw-context-token') {
        currentToken = value;
        break;
      }
    }
    
    // Append 123456 to current token
    const newToken = currentToken + '123456';
    
    // Set the modified cookie (with path and other attributes)
    document.cookie = `sw-context-token=${newToken}; path=/; SameSite=Lax`;
    
    alert(`Cookie modified!\nOld: ${currentToken}\nNew: ${newToken}`);
  };

  return (
    <div className="mb-4 p-3 border rounded">
      <h5 className="mb-3">Debug</h5>
      <div className="d-flex gap-2 flex-wrap">
        <button className="btn btn-primary" onClick={handleLogin} disabled={isLoggingIn}>
          {isLoggingIn ? 'Anmelden...' : 'Login'}
        </button>
        <button className="btn btn-danger" onClick={handleLogout} disabled={isLoggingOut}>
          {isLoggingOut ? 'Abmelden...' : 'Logout'}
        </button>
        <button className="btn btn-primary" onClick={handleFetchOrders} disabled={isFetchingOrders}>
          {isFetchingOrders ? 'Lade Bestellungen...' : 'Bestellungen abrufen'}
        </button>
        <button className="btn btn-primary" onClick={handleFetchCustomer} disabled={isFetchingCustomer}>
          {isFetchingCustomer ? 'Lade Kundendaten...' : 'Kundendaten abrufen'}
        </button>
        <button className="btn btn-secondary" onClick={handleTestAggregations}>
          Test Aggregations (Status Filter)
        </button>
        <button className="btn btn-warning" onClick={handleModifyContextToken}>
          Add '123456' to Token
        </button>
      </div>
    </div>
  );
};
